import { ENDPOINTS } from "config/endpoints";
import { useMutation, useQueryClient } from "react-query";
import Error from "types/error";
import client from "utils/client";
import { Request } from "types/request";
import { Response } from "types/response";
import { generatePath } from "react-router-dom";

export default function useNotifyPhotosUpload() {
  const queryClient = useQueryClient();

  const notifyPhotosUpload = (acquisitionId: string) => {
    const request: Request = {
      url: generatePath(ENDPOINTS.acquisitions.notifyPhotosUpload, {
        id: acquisitionId,
      }),
      config: {
        method: "patch",
        data,
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<Response<null>, Error, string>(
    notifyPhotosUpload,
    {
      onSettled: (data, error, variables) => {
        queryClient.invalidateQueries([ENDPOINTS.acquisitions.all]);
        queryClient.invalidateQueries([ENDPOINTS.acquisitions.one, variables]);
      },
    }
  );

  return { data, mutate, ...rest };
}
